import { styled } from '@mui/material';
import BgImage from '../../../assets/images/bg-secondary.png';

export const Container = styled('div')(({ theme, admin }) => ({
  fontSize: "1em",
  padding: 0,

}));

export const MainContainer = styled('div')(({ theme }) => ({
  margin: 0,
  padding: 0,
  height: '1550px',
  width: '1200px',
  position: 'relative',
  background: `#fff`,
  overflow: 'hidden',
  fontFamily: "WorkSans",
  fontWeight: 500,

}));

export const BannerContainer = styled('div')(({ theme, admin }) => ({
  position: 'fixed',
  width: admin ? 'calc(100% - 630px)' : 'calc(100% - 330px)',
  top: 0,
  right: 40,
  zIndex: 50,
  [theme.breakpoints.down('lg')]: {
    width: 'calc(100% - 40px)',
    top: 80,
    right: 20,
  },
  [theme.breakpoints.down('sm')]: {
    top: 60,
  },
}));
